import React from 'react'

interface SpinnerProps {
  size?: number
  className?: string
  hidden?: boolean
  text?: string
}

export default function Spinner({ size = 8, className, hidden = false, text }: SpinnerProps) {
  return (
    <div hidden={hidden}>
      <div className={`flex flex-col justify-center items-center ${className}`}>
        <div
          className={`w-${size} h-${size} border-2 border-sky-400 border-solid border-t-transparent rounded-full animate-spin`}
        ></div>
        {text && <span className='mt-4'>{text}</span>}
      </div>
    </div>
  )
}
